import type { Session, User } from '@/types/domain';

const TOKEN_KEY = 'token';
const USER_KEY = 'user';
const REMEMBER_KEY = 'rememberMe';

export const sessionStore = {
  getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY);
  },

  getUser(): User | null {
    const value = localStorage.getItem(USER_KEY);
    if (!value) return null;

    try {
      return JSON.parse(value) as User;
    } catch {
      localStorage.removeItem(USER_KEY);
      return null;
    }
  },

  get(): Session | null {
    const token = this.getToken();
    const user = this.getUser();
    return token && user ? { token, user } : null;
  },

  set(session: Session, rememberMe = '1 week'): void {
    localStorage.setItem(TOKEN_KEY, session.token.replace(/^Bearer\s+/i, '').trim());
    localStorage.setItem(USER_KEY, JSON.stringify(session.user));
    localStorage.setItem(REMEMBER_KEY, rememberMe);
  },

  updateUser(user: User): void {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  },

  clear(): void {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(REMEMBER_KEY);
  },
};
